import React, { useState } from 'react';
import mapboxgl from 'mapbox-gl';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';

mapboxgl.accessToken = 'pk.eyJ1IjoicHJhdGhhbTcwNCIsImEiOiJjbG1xaDJrdzEwNHVpMnFwaXloODIwc2Q0In0.M-0gUqeNHe6A9Z7LeaVFVw';

const Autocompletion = () => {
  const [searchResult, setSearchResult] = useState('');

  const handleSelect = (result) => {
    setSearchResult(result.result.text);
  };

  return (
    <div>
      <h1>Autocompletion Example</h1>
      <input
        type="text"
        placeholder="Search for a location"
        value={searchResult}
        onChange={(e) => setSearchResult(e.target.value)}
      />
      <div id="map"></div>
    </div>
  );
};

export default Autocompletion;
